import { Divider } from '@delmonicos/shared-design-system-react/src/components/divider/divider';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { TariffElementModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/tariff/tariff-element.model';
import { TariffDimensionType } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpi/src/enums/ocpi-protocol-enums';
import { useMemo } from 'react';

import { ComplexTariffComponent } from '@app/feature/tariff/tariff-details/cards/complex-tariff/complex-tariff.component';
import { FlatCardComponent } from '@app/feature/tariff/tariff-details/cards/flat-card.component';
import { InformationCardComponent } from '@app/feature/tariff/tariff-details/cards/information-card.component';
import { SimpleTariffCardComponent } from '@app/feature/tariff/tariff-details/cards/simple-tariff-card.component';
import { useTariffContext } from '@app/feature/tariff/tariff.context';

const hasRestrictions = (element: TariffElementModel) => {
  if (!element.restrictions) {
    return false;
  }
  return (
    element.restrictions.dayOfWeek ||
    element.restrictions.startTime ||
    element.restrictions.endTime ||
    element.restrictions.startDate ||
    element.restrictions.endDate
  );
};

export const TariffDetailsView = (): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const tariff = useTariffContext();

  const hasFlat = useMemo(() => {
    const firstElement = tariff.elements[0];
    return firstElement?.priceComponents.some(
      (p) => p.type === TariffDimensionType.FLAT,
    );
  }, [tariff]);

  // USER PERMISSIONS //////////////////////////////////////////////////////////

  // Nothing to do

  // ACTIONS ///////////////////////////////////////////////////////////////////

  // TABS //////////////////////////////////////////////////////////////////////

  // Nothing to do

  // RENDER ////////////////////////////////////////////////////////////////////

  const isComplexTariff = useMemo(() => {
    return tariff.elements.length >= 2 || tariff.elements.some(hasRestrictions);
  }, [tariff]);

  return (
    <Stack gap={GapEnum.M} direction="column">
      <InformationCardComponent />
      <Divider />
      {hasFlat && <FlatCardComponent />}

      {!isComplexTariff && <SimpleTariffCardComponent />}

      {isComplexTariff && <ComplexTariffComponent />}
    </Stack>
  );
};
